import { axiosInstance } from '../api';

// stopped = recruitment ended, ready for findings
// completed = findings already published
// in-progress = active, still recruiting
export default function() {
    return axiosInstance.get('/fhir/ResearchStudy?status=stopped,completed,in-progress&_sort=-_lastUpdated&_count=50');
}
